module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/h2-3b2ca1869305823356745eff1d481f63.svg";